export default "__VITE_ASSET__ZcJxabwG__"